import React, { useEffect, useState } from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Modal from 'src/components/common/Modal'
import RiskListItem from 'src/components/RiskCategories/RiskListItem.js'
import { COLORS } from 'src/utils/Themes/colors'

const CUTOFF_RISK_COUNT = 5

const TopRisks = ({ data }) => {
  const classes = useStyles()
  const [modalData, setModalData] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [riskLists, setRiskLists] = useState([])

  useEffect(() => {
    if (data) {
      const d = data
        ?.slice(0, CUTOFF_RISK_COUNT)
        ?.filter((e) => e?.insuranceType)
      setRiskLists(d)
    }

    return () => {
      setRiskLists([])
    }
  }, [data])

  const handleModal = (title, desc) => {
    setModalData({ title, desc })
    setTimeout(() => {
      setModalOpen(true)
    }, 240)
  }

  const CloseModal = () => {
    setModalOpen(false)
  }

  return (
    <>
      <div className={classes.root}>
        {modalOpen ? (
          <Modal
            // class={classes.modalRoot}
            bgcolor={COLORS?.WHITE}
            width={'40%'}
            left={'30%'}
            top={'14%'}
            ordered={modalOpen}
            modelClosed={CloseModal}
          >
            <div className={classes.modalContent} id='top-risk-modal'>
              <h2 className={classes.title}>{modalData?.title ?? null}</h2>
              <Typography>{modalData?.desc ?? null}</Typography>
            </div>
          </Modal>
        ) : null}
        <Card className={classes.cardContainer}>
          <CardContent>
            <h2 className={classes.title} id='top-risk-heading'>
              Top Exposures
            </h2>
            <div className={classes.riskListWrapper}>
              {riskLists?.map((item, index) => {
                const { insuranceType, risk } = item
                return (
                  <RiskListItem
                    key={`top-risks-${index}`}
                    title={insuranceType}
                    desc={risk}
                    handleClick={(t, d) => handleModal(t, d)}
                  />
                )
              })}
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default TopRisks

const useStyles = makeStyles({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
  },
  riskListWrapper: {
    marginTop: '10px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '0px',
    color: COLORS.GREY,
    display: 'flex',
    width: '100%',
    fontWeight: '600',
  },
  modalRoot: {
    width: '40% !important',
    left: '31.6% !important',
    '@media (max-width: 600px)': {
      width: '90% !important',
      left: '5% !important',
    },
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
  },
  cardContainer: {
    borderRadius: '10px',
    padding: '10px 6px 0px 10px',
    overflow: 'visible',
    boxShadow: '4px 7px 15px rgba(0, 0, 0, 0.1)',
    minHeight: '330px',
  },
})
